// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-NegotiatedSuppliers-styles___addProgram--AeIwG {
  display: flex;
  align-items: center;
  color: #1e8aff !important;
  font-size: 13px;
  cursor: pointer;
  margin-top: 26px;
}
  .components-NegotiatedSuppliers-styles___addProgram--AeIwG:hover {
    color: #f6f6f7;
  }
  .components-NegotiatedSuppliers-styles___addProgram--AeIwG {
  font-weight: 500;
}

.components-NegotiatedSuppliers-styles___addIcon--Y5Ci5 {
  height: 18px;
  margin-right: 5px;
}

.components-NegotiatedSuppliers-styles___loading--uyD8b {
  background: #f6f6f7;
  pointer-events: none;
}

.components-NegotiatedSuppliers-styles___paper--w1Lb2 {
  padding: 32px;
  max-width: 736px;
  margin: 0 0 30px;
}

.components-NegotiatedSuppliers-styles___header--IrPqU {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.components-NegotiatedSuppliers-styles___header--IrPqU h2 {
    flex: none;
    font-size: 17px;
    color: #1b2432;
    letter-spacing: 0;
    margin-bottom: 14px;
  }

.components-NegotiatedSuppliers-styles___table--AwxAV {
  margin: 20px 0 0;
}

.components-NegotiatedSuppliers-styles___tableHead--LGIEN {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-NegotiatedSuppliers-styles___tableRow--_DZkY {
  height: 68px !important;
}

.components-NegotiatedSuppliers-styles___tableRow--_DZkY:last-child .components-NegotiatedSuppliers-styles___tableCell--eFfdV {
      border: none;
    }

.components-NegotiatedSuppliers-styles___tableRow--_DZkY.components-NegotiatedSuppliers-styles___addNewTableRow--E663x {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
  }

.components-NegotiatedSuppliers-styles___tableRow--_DZkY td:first-child {
    padding-left: 0 !important;
  }

.components-NegotiatedSuppliers-styles___tableCell--eFfdV {
  font-size: 15px !important;
  padding: 16px 30px 16px 24px !important;
}

.components-NegotiatedSuppliers-styles___tableCell--eFfdV.components-NegotiatedSuppliers-styles___removeCell--_FYU0 {
    text-align: right;
    padding: 0 !important;
    width: 100px;
  }

.components-NegotiatedSuppliers-styles___tableCell--eFfdV.components-NegotiatedSuppliers-styles___removeCell--_FYU0 button {
      padding-left: 0;
      padding-right: 0;
    }

.components-NegotiatedSuppliers-styles___tableCell--eFfdV.components-NegotiatedSuppliers-styles___inputTableCell--G2DQY {
    padding: 16px 16px 16px 0 !important;
    width: 250px;
  }

.components-NegotiatedSuppliers-styles___tableCell--eFfdV.components-NegotiatedSuppliers-styles___inputTableCell--G2DQY > div {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

.components-NegotiatedSuppliers-styles___tableCell--eFfdV.components-NegotiatedSuppliers-styles___buttonTableCell--F_5Oj {
    padding: 16px 0 !important;
    text-align: right;
    width: 160px;
  }

.components-NegotiatedSuppliers-styles___corporateRateCodeTabs--mqaoA {
  border-bottom: none !important;
  margin-bottom: 6px;
}

.components-NegotiatedSuppliers-styles___corporateRateCodeTabs--mqaoA button {
    padding-bottom: 10px;
    border-bottom: 1px solid #c6c8cc !important;
  }

.components-NegotiatedSuppliers-styles___corporateRateCodeTabs--mqaoA button span {
      padding: 2px 5px;
    }

.components-NegotiatedSuppliers-styles___corporateRateCodeTabs--mqaoA span {
    text-transform: none !important;
    font-size: 17px;
    letter-spacing: 0;
  }
`, "",{"version":3,"sources":["webpack://./components/NegotiatedSuppliers/styles.pcss","<no source>"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,gBAAgB;AAKlB;EAJE;IACE,cAAc;EAChB;ECTF;EDUE;CCVF;;ADaA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AAQxB;;AAPE;IACE,UAAU;IACV,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AAezB;;AAZI;MACE,YAAY;IACd;;AAGF;IACE,+CAA+C;EACjD;;AAEA;IACE,0BAA0B;EAC5B;;AAGF;EACE,0BAA0B;EAC1B,uCAAuC;AA4BzC;;AA1BE;IACE,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EAMd;;AAJE;MACE,eAAe;MACf,gBAAgB;IAClB;;AAGF;IACE,oCAAoC;IACpC,YAAY;EAMd;;AAJE;MACE,wBAAwB;MACxB,2BAA2B;IAC7B;;AAGF;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;EACd;;AAEF;EACE,8BAA8B;EAC9B,kBAAkB;AAepB;;AAbE;IACE,oBAAoB;IACpB,2CAA2C;EAI7C;;AAHE;MACE,gBAAgB;IAClB;;AAGF;IACE,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;EACnB","sourcesContent":[".addProgram {\n  display: flex;\n  align-items: center;\n  color: #1e8aff !important;\n  font-size: 13px;\n  cursor: pointer;\n  margin-top: 26px;\n  &:hover {\n    color: #f6f6f7;\n  }\n  font-weight: 500;\n}\n\n.addIcon {\n  height: 18px;\n  margin-right: 5px;\n}\n\n.loading {\n  background: #f6f6f7;\n  pointer-events: none;\n}\n\n.paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 0 30px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  h2 {\n    flex: none;\n    font-size: 17px;\n    color: #1b2432;\n    letter-spacing: 0;\n    margin-bottom: 14px;\n  }\n}\n\n.table {\n  margin: 20px 0 0;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  height: 68px !important;\n\n  &:last-child {\n    .tableCell {\n      border: none;\n    }\n  }\n\n  &.addNewTableRow {\n    border-bottom: 1px solid rgba(224, 224, 224, 1);\n  }\n\n  td:first-child {\n    padding-left: 0 !important;\n  }\n}\n\n.tableCell {\n  font-size: 15px !important;\n  padding: 16px 30px 16px 24px !important;\n\n  &.removeCell {\n    text-align: right;\n    padding: 0 !important;\n    width: 100px;\n\n    button {\n      padding-left: 0;\n      padding-right: 0;\n    }\n  }\n\n  &.inputTableCell {\n    padding: 16px 16px 16px 0 !important;\n    width: 250px;\n\n    > div {\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n    }\n  }\n\n  &.buttonTableCell {\n    padding: 16px 0 !important;\n    text-align: right;\n    width: 160px;\n  }\n}\n.corporateRateCodeTabs {\n  border-bottom: none !important;\n  margin-bottom: 6px;\n\n  button {\n    padding-bottom: 10px;\n    border-bottom: 1px solid #c6c8cc !important;\n    span {\n      padding: 2px 5px;\n    }\n  }\n\n  span {\n    text-transform: none !important;\n    font-size: 17px;\n    letter-spacing: 0;\n  }\n}\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addProgram": `components-NegotiatedSuppliers-styles___addProgram--AeIwG`,
	"addIcon": `components-NegotiatedSuppliers-styles___addIcon--Y5Ci5`,
	"loading": `components-NegotiatedSuppliers-styles___loading--uyD8b`,
	"paper": `components-NegotiatedSuppliers-styles___paper--w1Lb2`,
	"header": `components-NegotiatedSuppliers-styles___header--IrPqU`,
	"table": `components-NegotiatedSuppliers-styles___table--AwxAV`,
	"tableHead": `components-NegotiatedSuppliers-styles___tableHead--LGIEN`,
	"tableRow": `components-NegotiatedSuppliers-styles___tableRow--_DZkY`,
	"tableCell": `components-NegotiatedSuppliers-styles___tableCell--eFfdV`,
	"addNewTableRow": `components-NegotiatedSuppliers-styles___addNewTableRow--E663x`,
	"removeCell": `components-NegotiatedSuppliers-styles___removeCell--_FYU0`,
	"inputTableCell": `components-NegotiatedSuppliers-styles___inputTableCell--G2DQY`,
	"buttonTableCell": `components-NegotiatedSuppliers-styles___buttonTableCell--F_5Oj`,
	"corporateRateCodeTabs": `components-NegotiatedSuppliers-styles___corporateRateCodeTabs--mqaoA`
};
module.exports = ___CSS_LOADER_EXPORT___;
